import { combineReducers } from "redux";
import theme from "./slices/themeSlice";
import auth from "./slices/authSlice";
import clickOutSideSlice from "./slices/clickOutSideSlice";
import settings from "./slices/settingSlice";
const rootReducer = (asyncReducers) => (state, action) => {
  const combinedReducer = combineReducers({
    theme,
    auth,
    settings,
    clickOutSideSlice,
    ...asyncReducers,
  });
  return combinedReducer(state, action);
};

export default rootReducer;
